/**
 * Created by Jie Gao on 2021-02-22.
 */
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {GGGameMode} from "../gamemode/GGGameMode";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class GGFreespinZeroBetController extends FreespinZeroBetController{

    constructor() {
        super();
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        return data.nextMode === GameMode.FREESPIN || data.nextMode === GGGameMode.FREESPIN_SUPER;
    }
}